"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdLaravelReport = require("cccisd-laravel-report");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TableReport = /*#__PURE__*/function (_Component) {
  _inherits(TableReport, _Component);
  function TableReport() {
    var _this;
    _classCallCheck(this, TableReport);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TableReport, [].concat(args));
    // render table cell with a binary value
    _defineProperty(_assertThisInitialized(_this), "_renderBinaryCell", function (value) {
      var icons = _this.props.reportProps.icons;
      var trueIcon = icons.find(function (item) {
        return item.value === true;
      });
      var falseIcon = icons.find(function (item) {
        return item.value === false;
      });
      var currentIcon;
      if ((0, _isNil2["default"])(value)) {
        return /*#__PURE__*/_react["default"].createElement("td", null);
      }
      if (value) {
        currentIcon = trueIcon;
        if (!(0, _isNil2["default"])(currentIcon)) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "icon"
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            width: "20",
            height: "20",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: currentIcon.viewBox,
            style: {
              fill: 'currentColor'
            }
          }, /*#__PURE__*/_react["default"].createElement("g", null, currentIcon.paths.map(function (p) {
            return /*#__PURE__*/_react["default"].createElement("path", {
              key: p,
              d: p
            });
          }))));
        }
        return value;
      }
      if (!value) {
        currentIcon = falseIcon;
        if (!(0, _isNil2["default"])(currentIcon)) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "icon"
          }, /*#__PURE__*/_react["default"].createElement("svg", {
            width: "20",
            height: "20",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: currentIcon.viewBox,
            style: {
              fill: 'currentColor'
            }
          }, /*#__PURE__*/_react["default"].createElement("g", null, currentIcon.paths.map(function (p) {
            return /*#__PURE__*/_react["default"].createElement("path", {
              key: p,
              d: p
            });
          }))));
        }
        return '';
      }
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].fade
      }, "``");
    });
    _defineProperty(_assertThisInitialized(_this), "_renderNull", function () {
      return /*#__PURE__*/_react["default"].createElement("td", null);
    });
    // render comment box
    _defineProperty(_assertThisInitialized(_this), "_renderCommentBox", function (number, name, dateStr, comment) {
      if ((0, _isNil2["default"])(comment)) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentInfo
      }, /*#__PURE__*/_react["default"].createElement("h2", null, name), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("h3", null, dateStr)), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, comment));
    });
    _defineProperty(_assertThisInitialized(_this), "processMatrixValues", function (value) {
      if (value === '1') {
        return true;
      }
      if (value === '0') {
        return false;
      }
      if (value === '99') {
        return 'null';
      }
      return value;
    });
    _defineProperty(_assertThisInitialized(_this), "getIcon", function (value) {
      var icons = _this.props.reportProps.icons;
      var match = icons.find(function (item) {
        return item.value === value;
      });
      if (match) {
        return match;
      }
      return value;
    });
    _defineProperty(_assertThisInitialized(_this), "_getCommentsForSessions", function (commentType) {
      var _this$props = _this.props,
        reportProps = _this$props.reportProps,
        child = _this$props.child;
      var commentTag = reportProps.commentTag;
      var hasScreen = !(0, _isNil2["default"])(child.screen);
      var hasPre = !(0, _isNil2["default"])(child.pre);
      var hasPost = !(0, _isNil2["default"])(child.post);
      var hasFollowUp = !(0, _isNil2["default"])(child.followUp);
      var comments = [];
      if (hasScreen) {
        var screenComment = (0, _get2["default"])(child.screen.devTags, commentTag);
        if (screenComment === null) {
          comments.push({
            label: 'Screen',
            comment: 'No Comments'
          });
        } else {
          comments.push({
            label: 'Screen',
            comment: screenComment
          });
        }
      }
      if (hasPre) {
        var preComment = (0, _get2["default"])(child.pre.devTags, commentTag);
        if (preComment === null) {
          comments.push({
            label: 'Pre',
            comment: 'No Comments'
          });
        } else {
          comments.push({
            label: 'Pre',
            comment: preComment
          });
        }
      }
      if (hasPost) {
        var postComment = (0, _get2["default"])(child.post.devTags, commentTag);
        if (postComment === null) {
          comments.push({
            label: 'Post',
            comment: 'No Comments'
          });
        } else {
          comments.push({
            label: 'Post',
            comment: postComment
          });
        }
      }
      if (hasFollowUp) {
        var followUpComment = (0, _get2["default"])(child.followUp.devTags, commentTag);
        if (followUpComment === null) {
          comments.push({
            label: 'Follow Up',
            comment: 'No Comments'
          });
        } else {
          comments.push({
            label: 'Follow UP',
            comment: followUpComment
          });
        }
      }
      return comments;
    });
    _defineProperty(_assertThisInitialized(_this), "getAnswerType", function () {
      var answerType = _this.props.reportProps.answerType;
      if (answerType === 'matrix') {
        return 'matrix';
      }
      if (answerType === 'likert') {
        return 'likert';
      }
      if (answerType === 'response') {
        return 'response';
      }
      return answerType;
    });
    _defineProperty(_assertThisInitialized(_this), "formatTableData", function () {
      var answerType = _this.getAnswerType();
      var tableData = [];
      if (answerType === 'matrix') {
        tableData = _this.formatMatrixTable();
      } else if (answerType === 'likert') {
        // Reserved for later
      } else if (answerType === 'response') {
        tableData = _this.formatResponseTable();
      } else {
        console.error("Invalid Answer Type: must be 'matrix', 'likert', or 'response'");
      }
      return tableData;
    });
    _defineProperty(_assertThisInitialized(_this), "formatMatrixTable", function () {
      var tableRows = [];
      var reportProps = _this.props.reportProps;
      var hasTimePoints = !(0, _isNil2["default"])(reportProps.responseSetLabels);
      if (hasTimePoints) {
        tableRows = _this.handleMatrixTimePoints();
      } else {
        var nullCheck = [];
        reportProps.tableRows.forEach(function (item) {
          var answer = _this.processMatrixValues((0, _get2["default"])(_this.props.child.metrics.devTags, item.dataPath));
          var newRow = [];
          newRow.push(item.question);
          if (answer === true) {
            newRow.push(_this._renderBinaryCell(true));
            newRow.push(' ');
            newRow.push(' ');
          } else if (answer === false) {
            newRow.push(' ');
            newRow.push(_this._renderBinaryCell(true));
            newRow.push(' ');
          } else if (answer === 'null') {
            newRow.push(' ');
            newRow.push(' ');
            newRow.push(_this._renderBinaryCell(true));
          } else if (answer === null) {
            nullCheck.push(answer);
          }
          tableRows.push(newRow);
        });
        if (nullCheck.length === reportProps.tableRows.length) {
          return 'All Null';
        }
      }
      return tableRows;
    });
    _defineProperty(_assertThisInitialized(_this), "handleMatrixTimePoints", function () {
      var child = _this.props.child;
      var tableData = [];
      var hasScreen = !(0, _isNil2["default"])(child.screen);
      var hasPre = !(0, _isNil2["default"])(child.pre);
      var hasPost = !(0, _isNil2["default"])(child.post);
      var hasFollowUp = !(0, _isNil2["default"])(child.followUp);
      if (hasScreen) {
        var path = child.screen;
        var screenTable = _this.processMatrixTimePoints(path);
        tableData.push(screenTable);
      }
      if (hasPre) {
        var _path = child.pre;
        var preTable = _this.processMatrixTimePoints(_path);
        tableData.push(preTable);
      }
      if (hasPost) {
        var _path2 = child.post;
        var postTable = _this.processMatrixTimePoints(_path2);
        tableData.push(postTable);
      }
      if (hasFollowUp) {
        var _path3 = child.followUp;
        var followUpTable = _this.processMatrixTimePoints(_path3);
        tableData.push(followUpTable);
      }
      return tableData;
    });
    _defineProperty(_assertThisInitialized(_this), "processMatrixTimePoints", function (path) {
      var reportProps = _this.props.reportProps;
      var newTable = [];
      var currentResponseSet = path.responseSet;
      var label = (0, _find2["default"])(reportProps.responseSetLabels, function (item) {
        return item.responseSet === currentResponseSet;
      });
      var nullCheck = [];
      reportProps.tableRows.forEach(function (row) {
        var newRow = [];
        var answer = _this.processMatrixValues((0, _get2["default"])(path.devTags, row.dataPath));
        newRow.push(row.question);
        if (answer === true) {
          newRow.push(_this._renderBinaryCell(true));
          newRow.push(' ');
          newRow.push(' ');
        } else if (answer === false) {
          newRow.push(' ');
          newRow.push(_this._renderBinaryCell(true));
          newRow.push(' ');
        } else if (answer === 'null') {
          newRow.push(' ');
          newRow.push(' ');
          newRow.push(_this._renderBinaryCell(true));
        } else if (answer === null) {
          nullCheck.push(answer);
        }
        newTable.push(newRow);
      });
      var hasLabel = !(0, _isNil2["default"])(label);
      if (nullCheck.length === reportProps.tableRows.length) {
        return 'All Null';
      }
      return {
        label: hasLabel ? label.label : '',
        responseSet: currentResponseSet,
        table: newTable
      };
    });
    _defineProperty(_assertThisInitialized(_this), "formatResponseTable", function () {
      var tableRows = [];
      var reportProps = _this.props.reportProps;
      var hasTimePoints = !(0, _isNil2["default"])(reportProps.responseSetLabels);
      if (hasTimePoints) {
        tableRows = _this.handleResponseTimePoints();
      } else {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          newRow.push(item.question);
          var answer = _this.convertBooleanValues((0, _get2["default"])(_this.props.child.metrics.devTags, item.dataPath));
          newRow.push(answer);
          tableRows.push(newRow);
        });
      }
      return tableRows;
    });
    _defineProperty(_assertThisInitialized(_this), "handleResponseTimePoints", function () {
      var reportProps = _this.props.reportProps;
      var tableData = [];
      var timePoints = reportProps.responseSetLabels;
      var timePointsArr = [];
      timePoints.forEach(function (item) {
        timePointsArr.push(item.label);
      });
      tableData = _this.handleScreen();
      if (!(0, _isNil2["default"])(tableData)) {
        return _this.getTableCells(tableData);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getTableCells", function (tableData) {
      var html = tableData.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: i
        }, item.map(function (thing) {
          return /*#__PURE__*/_react["default"].createElement("td", {
            style: {
              border: '1px solid #ccc',
              padding: '1em'
            }
          }, thing);
        }));
      });
      return html;
    });
    _defineProperty(_assertThisInitialized(_this), "handleScreen", function () {
      var _this$props2 = _this.props,
        child = _this$props2.child,
        reportProps = _this$props2.reportProps;
      var hasScreen = !(0, _isNil2["default"])(child.screen);
      var tableRows = [];
      if (hasScreen) {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          newRow.push(item.question);
          var answer = _this.convertBooleanValues((0, _get2["default"])(child.screen.devTags, item.dataPath));
          newRow.push(answer);
          tableRows.push(newRow);
        });
        return _this.handlePre(tableRows);
      }
      return _this.handlePre();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePre", function (tableRows) {
      var _this$props3 = _this.props,
        child = _this$props3.child,
        reportProps = _this$props3.reportProps;
      var hasTableRows = !(0, _isNil2["default"])(tableRows);
      var hasPre = !(0, _isNil2["default"])(child.pre);
      var newTableRows = [];
      if (hasTableRows && hasPre) {
        tableRows.forEach(function (row) {
          var match = (0, _find2["default"])(reportProps.tableRows, function (item) {
            return item.question === row[0];
          });
          var answer;
          if (match) {
            answer = _this.convertBooleanValues((0, _get2["default"])(child.pre.devTags, match.dataPath));
            if (!(0, _isNil2["default"])(answer)) {
              row.push(answer);
            }
          }
          newTableRows.push(row);
        });
        return _this.handlePost(newTableRows);
      }
      if (!hasTableRows && hasPre) {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          newRow.push(item.question);
          var answer = _this.convertBooleanValues((0, _get2["default"])(_this.props.child.pre.devTags, item.dataPath));
          newRow.push(answer);
          newTableRows.push(newRow);
        });
        return _this.handlePost(newTableRows);
      }
      return _this.handlePost();
    });
    _defineProperty(_assertThisInitialized(_this), "handlePost", function (tableRows) {
      var _this$props4 = _this.props,
        child = _this$props4.child,
        reportProps = _this$props4.reportProps;
      var hasTableRows = !(0, _isNil2["default"])(tableRows);
      var hasPost = !(0, _isNil2["default"])(child.post);
      var newTableRows = [];
      if (hasTableRows && hasPost) {
        tableRows.forEach(function (row) {
          var match = (0, _find2["default"])(reportProps.tableRows, function (item) {
            return item.question === row[0];
          });
          var answer;
          if (match) {
            answer = _this.convertBooleanValues((0, _get2["default"])(child.post.devTags, match.dataPath));
            if (!(0, _isNil2["default"])(answer)) {
              row.push(answer);
            }
          }
          newTableRows.push(row);
        });
        return _this.handleFollowUp(newTableRows);
      }
      if (!hasTableRows && hasPost) {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          newRow.push(item.question);
          var answer = _this.convertBooleanValues((0, _get2["default"])(_this.props.child.post.devTags, item.dataPath));
          newRow.push(answer);
          newTableRows.push(newRow);
        });
        return _this.handleFollowUp(newTableRows);
      }
      return _this.handleFollowUp();
    });
    _defineProperty(_assertThisInitialized(_this), "handleFollowUp", function (tableRows) {
      var _this$props5 = _this.props,
        child = _this$props5.child,
        reportProps = _this$props5.reportProps;
      var hasTableRows = !(0, _isNil2["default"])(tableRows);
      var hasFollowUp = !(0, _isNil2["default"])(child.followUp);
      var newTableRows = [];
      if (hasTableRows && hasFollowUp) {
        tableRows.forEach(function (row) {
          var match = (0, _find2["default"])(reportProps.tableRows, function (item) {
            return item.question === row[0];
          });
          var answer;
          if (match) {
            answer = _this.convertBooleanValues((0, _get2["default"])(child.followUp.devTags, match.dataPath));
            if (!(0, _isNil2["default"])(answer)) {
              row.push(answer);
            }
          }
          newTableRows.push(row);
        });
        return newTableRows;
      }
      if (!hasTableRows && hasFollowUp) {
        reportProps.tableRows.forEach(function (item) {
          var newRow = [];
          newRow.push(item.question);
          var answer = _this.convertBooleanValues((0, _get2["default"])(_this.props.child.followUp.devTags, item.dataPath));
          newRow.push(answer);
          newTableRows.push(newRow);
        });
        return newTableRows;
      }
      return tableRows;
    });
    _defineProperty(_assertThisInitialized(_this), "convertBooleanValues", function (value) {
      if (value === '1') {
        return 'Yes';
      }
      if (value === '0') {
        return 'No';
      }
      if (value === null) {
        return '';
      }
      return value;
    });
    return _this;
  }
  _createClass(TableReport, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        isReport = _this$props6.isReport,
        reportProps = _this$props6.reportProps;
      var reportStyle = isReport ? _style["default"].report + ' ' + _style["default"].paginated : _style["default"].report;
      var hasColumnHeaders = !(0, _isNil2["default"])(reportProps.answerColumnHeaders) && reportProps.answerColumnHeaders.length !== 0;
      var hasMultipleTimePoints = !(0, _isNil2["default"])(reportProps.responseSetLabels) && reportProps.responseSetLabels.length !== 0;
      var hasMetrics = !(0, _isNil2["default"])(this.props.child.screen) || !(0, _isNil2["default"])(this.props.child.pre) || !(0, _isNil2["default"])(this.props.child.post) || !(0, _isNil2["default"])(this.props.child.followUp) || !(0, _isNil2["default"])(this.props.child.metrics);
      var isMatrixTable = reportProps.answerType === 'matrix';
      var isResponseTable = reportProps.answerType === 'response';
      var hasComments = !(0, _isNil2["default"])(reportProps.commentTag);
      var tableData;
      var hasData;
      var comments;
      if (hasMetrics) {
        tableData = this.formatTableData();
        if (tableData) {
          if (tableData[0] === 'All Null') {
            hasData = false;
          } else {
            hasData = true;
          }
        }
      }
      if (hasComments) {
        comments = this._getCommentsForSessions();
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: reportStyle
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, {
        showPagination: isReport
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].toPdf
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportContentWrapper
      }, this.props.header, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, isReport && /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: this.props.reportProps.description
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].sessionsArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, reportProps.tableTitle), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: reportProps.tableDescription
      })), hasData ? /*#__PURE__*/_react["default"].createElement("div", null,
      // for Single Time Point Tables
      !hasMultipleTimePoints && /*#__PURE__*/_react["default"].createElement("table", {
        className: _style["default"].groupTable
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
        key: "labelRow"
      }, /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: "2",
        className: _style["default"].leftAlign + ' ' + _style["default"].bottomVert
      }, reportProps.rowColTitle), hasColumnHeaders ? reportProps.answerColumnHeaders.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: item.label,
          style: {
            overflow: 'wrap',
            paddingLeft: '1em',
            paddingRight: '1em',
            maxWidth: '25%'
          }
        }, item.label);
      }) : /*#__PURE__*/_react["default"].createElement("th", null, "No Headers")), /*#__PURE__*/_react["default"].createElement("tr", {
        className: _style["default"].numbersHeaderRow
      })), /*#__PURE__*/_react["default"].createElement("tbody", null, hasMetrics && isMatrixTable ? tableData.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: i
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            textAlign: 'left',
            paddingRight: '1em',
            width: '30%'
          }
        }, item[0]), /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            width: '20%'
          }
        }, item[1]), /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            width: '20%'
          }
        }, item[2]), /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            width: '20%'
          }
        }, item[3]));
      }) : /*#__PURE__*/_react["default"].createElement("tr", {
        style: {
          display: 'none'
        }
      }), hasMetrics && isResponseTable ? tableData.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: i
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            textAlign: 'left',
            paddingRight: '1em',
            width: '50%'
          }
        }, item[0]), /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            border: '1px solid #ccc',
            width: '50%'
          }
        }, item[1]));
      }) : /*#__PURE__*/_react["default"].createElement("tr", {
        style: {
          display: 'none'
        }
      }))), hasMultipleTimePoints && hasMetrics && isMatrixTable && tableData.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].sessionsArea
        }, /*#__PURE__*/_react["default"].createElement("h1", null, item.label), /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
          key: i
        }, /*#__PURE__*/_react["default"].createElement("th", {
          rowSpan: "2",
          className: _style["default"].leftAlign + ' ' + _style["default"].bottomVert
        }, reportProps.rowColTitle), hasColumnHeaders ? reportProps.answerColumnHeaders.map(function (thing) {
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: thing.label,
            style: {
              overflow: 'wrap',
              paddingLeft: '1em',
              paddingRight: '1em'
            },
            s: true
          }, thing.label);
        }) : /*#__PURE__*/_react["default"].createElement("th", null, "No Headers")), /*#__PURE__*/_react["default"].createElement("tr", {
          className: _style["default"].numbersHeaderRow
        })), /*#__PURE__*/_react["default"].createElement("tbody", null, item.table.map(function (row, r) {
          return /*#__PURE__*/_react["default"].createElement("tr", {
            key: r
          }, /*#__PURE__*/_react["default"].createElement("td", {
            style: {
              border: '1px solid #ccc',
              textAlign: 'left',
              paddingRight: '1em',
              width: '30%'
            }
          }, row[0]), /*#__PURE__*/_react["default"].createElement("td", {
            style: {
              border: '1px solid #ccc',
              width: '20%'
            }
          }, row[1]), /*#__PURE__*/_react["default"].createElement("td", {
            style: {
              border: '1px solid #ccc',
              width: '20%'
            }
          }, row[2]), /*#__PURE__*/_react["default"].createElement("td", {
            style: {
              border: '1px solid #ccc',
              width: '20%'
            }
          }, row[3]));
        })))));
      }), hasMetrics && hasMultipleTimePoints && isResponseTable && /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: "2",
        className: _style["default"].leftAlign + ' ' + _style["default"].bottomVert
      }, reportProps.rowColTitle), /*#__PURE__*/_react["default"].createElement("th", {
        colSpan: "10"
      }, this.props.reportProps.sessionLabelPlural)), /*#__PURE__*/_react["default"].createElement("tr", {
        className: _style["default"].numbersHeaderRow
      }, reportProps.responseSetLabels.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("th", null, item.label);
      }))), /*#__PURE__*/_react["default"].createElement("tbody", null, tableData))) : /*#__PURE__*/_react["default"].createElement("h4", null, "NO APPLICABLE TIMEPOINTS FOR THIS MEASURE")), hasMetrics && hasComments && hasData && /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].contentWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].commentsArea
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Comments"), comments.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: i
        }, ' ', /*#__PURE__*/_react["default"].createElement("h2", null, item.label), /*#__PURE__*/_react["default"].createElement("div", null, item.comment), ' ');
      }))))))))));
    }
  }]);
  return TableReport;
}(_react.Component);
TableReport.propTypes = {
  // the active child
  child: _propTypes["default"].object,
  // props pass through from appdefs
  reportProps: _propTypes["default"].object,
  // Full rendered markup for the header
  header: _propTypes["default"].node,
  // whether to render in report page
  isReport: _propTypes["default"].bool
};
var _default = exports["default"] = TableReport;